<template>
    <h5 class="mb-3">
        Pick an admin task...
    </h5>

    <div class="list-group">
        <router-link
            to="/admin/series/"
            class="list-group-item list-group-item-action"
        >
            <h6 class="mb-1">
                Series
            </h6>
            <small class="mb-1">
              Edit series, lessons, components and translations.
            </small>
        </router-link>

        <router-link
            to="/admin/users/"
            class="list-group-item list-group-item-action"
        >
            <h6 class="mb-1">
                Users
            </h6>
            <small class="mb-1">
              Edit users and their role.
            </small>
        </router-link>

        <router-link
            to="/admin/languages/"
            class="list-group-item list-group-item-action"
        >
            <h6 class="mb-1">
                Languages
            </h6>
            <small class="mb-1">
              Edit available languages for translation.
            </small>
        </router-link>

        <router-link
            to="/admin/categories/"
            class="list-group-item list-group-item-action"
        >
            <h6 class="mb-1">
                Categories
            </h6>
            <small class="mb-1">
              Edit series categories.
            </small>
        </router-link>

        <router-link
            to="/admin/media/"
            class="list-group-item list-group-item-action"
        >
            <h6 class="mb-1">
                Media
            </h6>
            <small class="mb-1">
              Upload series and lesson media.
            </small>
        </router-link>

        <router-link
            to="/admin/assets/"
            class="list-group-item list-group-item-action"
        >
            <h6 class="mb-1">
                Assets
            </h6>
            <small class="mb-1">
              Upload assets for use in components.
            </small>
        </router-link>

        <router-link
            to="/admin/arabic-assets/"
            class="list-group-item list-group-item-action"
        >
            <h6 class="mb-1">
                Arabic Assets
            </h6>
            <small class="mb-1">
              Material in Arabic.
            </small>
        </router-link>

        <router-link
            to="/admin/pages/"
            class="list-group-item list-group-item-action"
        >
            <h6 class="mb-1">
                Pages
            </h6>
            <small class="mb-1">
              Pages in the CMS.
            </small>
        </router-link>
    </div>
</template>

<script>
import Navigation from "../../partials/Navigation.vue";

export default {
  name: "Dashboard",

  components: {
    Navigation,
  },
};
</script>
